<div class="w-full p-3 rounded-lg bg-gray-50 dark:bg-gray-900">
  <div class="w-full my-2 pb-2 border-b border-gray-100 dark:border-gray-600">
    <p class="text-gray-500 text-sm">
      تلفیق
      {{ mergeTitle }}
    </p>
  </div>

  <div class="w-full mt-3">
    <!-- authors -->
    @if(mergeAuthorsList?.length > 0){
    @for (item of mergeAuthorsList; track $index) {
    <ng-container *ngTemplateOutlet="MergeItemTemplate; context: { item }">
    </ng-container>
    }
    }
    <!-- publishers -->
    @if(mergePublisherList?.length > 0){
    @for (item of mergePublisherList; track $index) {
    <ng-container *ngTemplateOutlet="MergeItemTemplate; context: { item }">
    </ng-container>
    }
    }
    <!-- books -->
    @if(mergeBookList?.length > 0){
    @for (item of mergeBookList; track $index) {
    <ng-container *ngTemplateOutlet="MergeItemTemplate; context: { item }">
    </ng-container>
    }
    }
  </div>

  <button [appButtonLoader]="isLoading" class="w-full btn-green-flat my-3" type="button"
    [disabled]="mergeAuthorsList?.length < 1 && mergePublisherList?.length < 1 && mergeBookList?.length < 1"
    (click)="gotoMerge()">
    ادامه فرآیند ترکیب
  </button>
</div>

<ng-template #MergeItemTemplate let-item="item">
  <div class="w-full flex justify-between  mb-3 items-center">
    <div class="grow">
      <a class="cursor-pointer flex justify-start items-center" tabindex="-1"
        [routerLink]="[(mergeBookList?.length > 0) ? routes.book :routes.profile, item?.id]"
        (click)="dialog.closeAll()">
        @if(mergeBookList?.length > 0){
        <img loading="lazy" class="book-sm ml-2 object-cover"
          onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_book'"
          src="{{ item?.id | image : imageType.book : item?.hasPhoto }}" width="48" height="48" [alt]="item.name" />
        }
        @else if(mergePublisherList?.length > 0){
        <img loading="lazy" class="avatar-md ml-2"
          onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_avatar.svg'"
          src="{{ item?.id | image : imageType.publisherAvatar : item?.hasPhoto }}" width="48" height="48"
          [alt]="item.name" />
        }
        @else{
        <img loading="lazy" class="avatar-md ml-2"
          onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_avatar.svg'"
          src="{{ item?.id | image : imageType.authorAvatar : item?.hasPhoto }}" width="48" height="48"
          [alt]="item.name" />
        }
        <span class="text-sm font-medium text-gray-900 mr-1">{{
          item.name
          }}</span>
      </a>
    </div>

    <button
      class="focus-visible:outline-none focus-visible:border-none w-7 h-7 !min-w-7 !min-h-7 !px-0 rounded-full flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gary-700"
      (click)="removeItem(item)">
      <span class="icon dismiss-regular text-gray-700 text-sm"></span>
    </button>
  </div>
</ng-template>